import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, AlertTitle, Checkbox, FormControlLabel, IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import helpers from '../../utils/helpers';

const OptionableAlert = (props) => {
  const { name, title, body, permanent } = props;
  const [doNotShowCheckbox, setDoNotShowCheckbox] = useState(false);
  const [show, setShow] = useState(false);

  const onClose = () => {
    setShow(false);
    if (doNotShowCheckbox) {
      helpers.setSiteOptions(name, true);
    }
  };

  useEffect(() => {
    const opt = helpers.getSiteOptions(name);
    setShow(!opt);
  }, []);

  return (
    <>
      {
        show && (
          <Alert
            severity="warning"
            sx={{
              width: '100%',
              border: 1,
              position: 'relative',
            }}
            action={!permanent && (
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={onClose}
              >
                <Close fontSize="inherit" />
              </IconButton>
            )}
          >
            <AlertTitle>{title}</AlertTitle>
            <Typography
              variant="body1"
              fontWeight={500}
            >
              {body}
            </Typography>
            <br />
            {
              !permanent && (
                <FormControlLabel
                  sx={{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                  }}
                  control={(
                    <Checkbox
                      size="small"
                      checked={doNotShowCheckbox}
                      onChange={() => {
                        setDoNotShowCheckbox((prev) => !prev);
                      }}
                    />
                  )}
                  label="Bir daha gösterme"
                />
              )
            }
          </Alert>
        )
      }
    </>
  );
};

export default OptionableAlert;

OptionableAlert.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.any,
  permanent: PropTypes.bool
};
